/**
 * Lưu queue access token PER-ĐỢT (multi-period) vào sessionStorage — clear khi đóng tab.
 * Inject vào header X-Queue-Token cho POST/DELETE /api/registration của ĐÚNG đợt đang chọn.
 * Token namespace theo periodId vì access token backend là period-scoped (reg:access:{pid}:{idSv}).
 */
import { getActivePeriodId } from "../api/apiClient";

const KEY = "queue_token_map"; // JSON { [periodId]: token }

const readMap = (): Record<string, string> => {
    try {
        const raw = sessionStorage.getItem(KEY);
        return raw ? JSON.parse(raw) as Record<string, string> : {};
    } catch {
        return {};
    }
};

const writeMap = (map: Record<string, string>) => {
    sessionStorage.setItem(KEY, JSON.stringify(map));
};

/** Lưu token cho 1 đợt cụ thể (mặc định đợt đang chọn nếu không truyền periodId). */
export const setQueueToken = (token: string, periodId?: number) => {
    const pid = periodId ?? getActivePeriodId();
    if (!pid) return;
    const map = readMap();
    map[String(pid)] = token;
    writeMap(map);
};

/** Lấy token của đợt đang chọn (đợt mà X-Period-Id trỏ tới). */
export const getQueueToken = (): string | null => {
    const pid = getActivePeriodId();
    if (!pid) return null;
    return readMap()[String(pid)] ?? null;
};

/** Xoá token của 1 đợt (mặc định đợt đang chọn). */
export const clearQueueToken = (periodId?: number) => {
    const pid = periodId ?? getActivePeriodId();
    if (!pid) {
        sessionStorage.removeItem(KEY);
        return;
    }
    const map = readMap();
    delete map[String(pid)];
    writeMap(map);
};
